var GuildBossConst = {
    // 伤害排行榜
    rank: {
        guild: 1,
        role: 2
    },

    status: {
        activity: 0,
        un_activity: 1,
        pass_activity: 2
    },

    type: {
        physics: 2,            // 推荐物理
        magic: 1,              // 推荐法系
    }
}

module.exports = GuildBossConst